import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import { Box, Typography } from "@mui/material";
import { formatter } from "../../helper/functions";

const sampledata = [
  { name: "Jan", uv: 11000, pv: 22000 },
  { name: "Feb", uv: 15000, pv: 13980 },
  { name: "Mar", uv: 20000, pv: 25800 },
  { name: "Apr", uv: 28753, pv: 14000 },
  { name: "May", uv: 19000, pv: 26800 },
  { name: "Jun", uv: 25000, pv: 13000 },
  { name: "Jul", uv: 30000, pv: 20000 },
  { name: "Aug", uv: 28000, pv: 24000 },
  { name: "Sep", uv: 27000, pv: 18000 },
  { name: "Oct", uv: 26000, pv: 12000 },
  { name: "Nov", uv: 24000, pv: 17000 },
  { name: "Dec", uv: 23000, pv: 26000 },
];

const TotalRevenueLineChart = ({ data, year }) => {
  return (
    <Box sx={{ marginLeft: "-40px" }}>
      {/* Provide fixed width and height to LineChart */}
      <LineChart
        width={800}
        height={150}
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid horizontal={false} strokeDasharray="1 0" />
        <XAxis
          axisLine={false}
          tickLine={false}
          tick={{
            fontSize: "11px",
            fontWeight: 400,
          }}
          dataKey="name"
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          tick={{
            fontSize: "12px",
            fontWeight: 600,
          }}
          domain={[10000, 30000]}
          ticks={[10000, 20000, 30000]}
          tickFormatter={(value) => `$${value / 1000}k`}
        />
        <Tooltip
          content={(data) => {
            return (
              <Box sx={{ backgroundColor: "#683C8C59", padding: "10px" }}>
                <Typography color={"#683C8C"} sx={{ fontWeight: 600 }}>
                  {data.payload[0]?.payload?.name} {year} -{" "}
                  {formatter.format(data.payload[0]?.value / 1000)}k
                </Typography>
                <Typography color={"#683C8C"} sx={{ fontWeight: 600 }}>
                  {data.payload[1]?.payload?.name} {year - 1} -{" "}
                  {formatter.format(data.payload[1]?.value / 1000)}k
                </Typography>
              </Box>
            );
          }}
          formatter={(value) => `${formatter.format(value / 1000)}k`}
        />
        <Line
          type="monotone"
          dataKey="pv"
          stroke="rgba(104, 60, 140, 1)"
          strokeWidth={2}
        />
        <Line
          type="monotone"
          dataKey="uv"
          stroke="rgba(104, 60, 140, 0.35)"
          strokeWidth={2}
        />
      </LineChart>
    </Box>
  );
};

export default TotalRevenueLineChart;
